module.exports = __webpack_public_path__ + "media/src/images/site-top/image4-a3fe73914fb32a12fed48e2ac0d6fb90.jpg";